import Label from 'LuxKit/Label'
import { isMobileAppDevice } from 'lib/web/deviceUtils'
import React from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'

interface Props {
  experienceOffer?: App.ExperienceOffer
  isMobileApp: boolean
  discountPercentage?: number
  showOnlyOnMobile?: boolean
}

function ExperienceAppDiscountTag(props: Props) {
  const { isMobileApp, experienceOffer, discountPercentage, showOnlyOnMobile = true } = props
  const intl = useIntl()
  const percentage = discountPercentage ?? experienceOffer?.pricing.mobileAppDiscountPercentage

  if ((showOnlyOnMobile && !isMobileApp) || !percentage) return null

  return (
    <Label kind="primary" variant="highlight-secondary">
      {intl.formatMessage(
        {
          id: 'LSWLK_Amxvvns5PLwPkX',
          defaultMessage: '{percentage}% app discount',
          description: 'Label showing mobile app discount percentage for experience',
        },
        { percentage },
      )}
    </Label>
  )
}

const mapStateToProps = (state: App.State) => ({
  isMobileApp: isMobileAppDevice(state.system.rawUserAgentString),
})

export default connect(mapStateToProps)(ExperienceAppDiscountTag)
